<template>
  <div
    v-if="loading"
    class="is-loading"
  >
    <v-progress-linear
      indeterminate
      color="#B2E6F6"
      size="30"
    />
    {{ $t('siteDashboard.loading') }}
  </div>


  <div
    v-else
    class="notification"
  >
    <div :class="className">
      <img :src="icon">

      <div class="notification-details">
        <div class="alert-title">
          <div>{{ notification.alert.name }}</div>
        </div>

        <div class="alert-details">
          <AnalysisData
            v-if="alertDetails.analysisData"
            :data="alertDetails.analysisData[0]"
          />
          <InventoryData
            v-if="alertDetails.inventoryData"
            :data="alertDetails.inventoryData[0]"
          />
          <div class="pdf-report">
            <a
              class="pdf-report"
              @click="downloadReport"
            >
              <div>{{ $t('siteDashboard.reports') }}</div>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AnalysisData from './AnalysisData.vue';
import InventoryData from './InventoryData.vue';

export default {
    name: 'Notification',

    components: {
        AnalysisData,
        InventoryData,
    },

    props: {
        notification: {
            type: Object,
            default: () => ({
                id: 'string',
                alert: {
                    createdAt: 'null',
                    id: 'null',
                    name: 'null',
                    type: 'Inventory',
                },
            }),
        },
        siteId: {
            type: String,
            default: () => '',
        },
    },
    data() {
        return {
            loading: false,
            alertDetails: null,
        };
    },
    computed: {
        className() {
            return `notification ${this.notification.alert.type.toLowerCase()}-notification`;
        },

        icon() {
            if (this.notification.alert.type === 'Analysis') return '/dashboard/analysisNotification.svg';
            if (this.notification.alert.type === 'Inventory') return '/dashboard/inventoryNotification.svg';

            return '/dashboard/analysisNotification.svg';
        },
    },

    async created() {
        await this.getAlert();
    },

    methods: {
        async getAlert() {
            this.loading = true;

            const { data } = await this.$rq.getSiteNotificationDetail(this.siteId, this.notification.id);

            this.alertDetails = { ...data };

            this.loading = false;
        },

        async downloadReport() {
            const { data } = await this.$rq.downloadFile(this.notification.report.file.id);

            this.$utils.saveFileOnDisk(data, this.notification.report.file.fileName);
        },
    },
};
</script>

<style lang="scss" scoped>
.notification {
    display: flex;
    align-items: center;
    justify-content: flex-start;

    width: 100%;
    padding: 10px;

    color: black;

    &:not(:first-child) {
        border-top: 1px solid #DEDEDE;
    }
}

.is-loading {
    padding: 20px;

    color: rgba(20, 20, 20, 0.25);

    font-size: 12px;
    text-align: center;
}

.notification-details {
    display: flex;
    flex-direction: column;
}

.alert-details {
    display: flex;
}
.notification img{
    width: 25px;
    height: 25px;
    margin-right: 24px;
    padding: 4px;

    background: #EF4135;
    border-radius: 5px;
}

.pdf-report a {
    font-size: 12px;
    text-decoration: underline;
    color: #EF4135;
}
</style>
